import Vue from 'vue';
import accountService from './../account';
import store from './../../store';

/**
 * When the request succeeds
 */
const success = (response, resolve) => {
  if (response.verification) {
    const token = response.token;
    const userId = response.user_id;
    const verificationType = response.verification;
    const mobileNumber = response.mobile_number;
    store.dispatch('twoFactorVerification', {
      token,
      userId,
      verificationType,
      mobileNumber,
    });
    Vue.router.push({
      name: 'auth.twoFactorVerification',
    });
    resolve();
  } else {
    store.dispatch('login', response.token);
    accountService.find().then(() => {
      Vue.router.push({
        name: 'dashboard',
      });
      resolve();
    });
  }
};

/**
 * When the request fails
 */
const failed = (error, reject) => {
  // Handle CORS errors, network errors, or cases where response is undefined
  if (!error.response) {
    // CORS error, network error, or server not reachable
    const errorMessage = error.message || 'Unable to connect to server. Please check your connection.';
    return reject({ errors: [errorMessage] });
  }

  // Handle API errors with response
  const errorCode = error.response.data && error.response.data.error
    ? error.response.data.error.code
    : 0;

  // Allow lockout (42901) and subscription ended (42206) errors to pass through
  // These have specific messages that should be displayed to the user
  if (error.response.statusText === 'Unauthorized' && errorCode !== 42206 && errorCode !== 42901) {
    return reject({ errors: ['Invalid credentials'] });
  }

  // Return error data if available, otherwise return generic error
  if (error.response.data) {
    return reject(error.response.data);
  }

  // Fallback for unexpected error format
  return reject({
    errors: [`Request failed with status ${error.response.status || 'unknown'}`],
  });
};

export default user => (
  new Promise((resolve, reject) => {
    Vue.$http.post('/auth', user)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/auth/login.js